import { useState } from "react";
import { ProgressBar } from "react-bootstrap";
import { TextInput } from "./CustomForm";
import { uploadFile } from "../../utils/uploadImage";
import { toast } from "react-toastify";
import { toastOptions } from "../../utils/error";
/**
  accept for pdf = ".pdf"
  accept for image = "image/*"
*/

function UploadFileComp({
  file,
  setFile,
  fileType,
  imageMargin,
  isDimension,
  getError,
  setError,
  index,
  productId,
  ...props
}) {
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [isUploaded, setIsUploaded] = useState(false);
  const uploadPercentageHandler = (per) => {
    setUploadPercentage(per);
  };
  // console.log(file);

  const isFileArray = Array.isArray(file);
  console.log(isFileArray);
  const token = JSON.parse(localStorage.getItem("token"));
  const uploadImageS3 = async (doc) => {
    // After I get API for image
    console.log(doc);
    try {
      // console.log({ fileType, token });
      const location = await uploadFile({
        file: doc,
        fileType: doc.type,
        token,
        percentHandler: uploadPercentageHandler,
      });
      console.log("location", location);

      if (location.error) {
        isFileArray ? setFile([...file]) : setFile("");
        throw location.error;
      }

      console.log(location);
      isFileArray ? setFile([...file, location]) : setFile(location);
      console.log(file);
      setTimeout(() => {
        setUploadPercentage(0);
        setIsUploaded(true);
      }, 1000);
    } catch (error) {
      console.log(error);
      toast.error(error, toastOptions);
    }

    // For Now will remove once get the API
    // const location = URL.createObjectURL(doc);
    // isFileArray ? setFile([...file, location]) : setFile(location);
    uploadPercentageHandler(0);
  };

  const getDimAndUpload = async (image) => {
    // read file using fileReader
    const reader = new FileReader();
    reader.onload = (e) => {
      console.log("READER ONLOAD", e);
      // creating image element to get the dimension
      const img = new Image();
      img.src = e.target.result;

      img.onload = async () => {
        if (img.width !== 358 || img.height !== 110) {
          toast.warning("Image size should be 358 x 110", toastOptions);
          getError && setError("Image size should be 358 x 110");
          setFile(null);
          return;
        } else {
          getError && setError(null);
          await uploadImageS3(image);
        }
      };
    };

    reader.readAsDataURL(image);
  };

  const uploadFileHandler = async (e, type) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) {
      isFileArray ? setFile([...file]) : setFile("");
      return;
    }
    console.log("jjihiuguyg");
    if (selectedFile.size > 5000000) {
      toast.warning("File size is too large. (max size 5MB)", toastOptions);
      isFileArray ? setFile([...file]) : setFile("");
      return;
    }

    if (isDimension) {
      await getDimAndUpload(selectedFile);
    } else {
      await uploadImageS3(selectedFile);
    }

    // console.log(selectedFile);
    // isFileArray ? setFile([...file, selectedFile]) : setFile(selectedFile);
  };
  return (
    <>
      <TextInput
        {...props}
        type="file"
        onChange={(e) => uploadFileHandler(e)}
      />
      {!isUploaded && uploadPercentage > 0 && (
        <ProgressBar
          now={uploadPercentage}
          active
          label={`${uploadPercentage}%`}
          style={{ width: "70%" }}
        />
      )}

      {/* {isFileArray
        ? file.length > 0 && (
            <img
              src={file[index]}
              width={50}
              height={50}
              className={imageMargin}
              alt="uploading_image"
            />
          )
        : file && (
            <img
              src={file}
              width={50}
              height={50}
              className={imageMargin}
              // alt="uploading_image"
            />
          )} */}
    </>
  );
}

export default UploadFileComp;
